/** Android Chromeだけ、CM6の実験的EditContext経路を従来の入力経路へ戻す。 */
export function isAndroidUserAgent(userAgent: string): boolean {
  return /\bAndroid\b/i.test(userAgent);
}

/**
 * Android版CM6のEditContext経路では、Gboardが持つ変換分節のうちアクティブな分節を
 * 表示できない。EditorView生成中だけ内部スイッチをfalseにし、contenteditable経路を使う。
 *
 * `EDIT_CONTEXT` はCM6の公開APIではないため、影響範囲を同期的な生成処理だけに限定し、
 * 非Androidでは触らない。CM6側で分節表示が直った版へ更新するときは、この処理を外して
 * Android実機のIMEチェックリストを再実施する。
 */
export function createWithAndroidImeFallback<T>(
  userAgent: string,
  editorViewConstructor: { EDIT_CONTEXT?: boolean },
  create: () => T,
): T {
  if (!isAndroidUserAgent(userAgent)) return create();

  const hadOwnValue = Object.prototype.hasOwnProperty.call(editorViewConstructor, 'EDIT_CONTEXT');
  const previous = editorViewConstructor.EDIT_CONTEXT;
  editorViewConstructor.EDIT_CONTEXT = false;

  try {
    return create();
  } finally {
    if (hadOwnValue) editorViewConstructor.EDIT_CONTEXT = previous;
    else delete editorViewConstructor.EDIT_CONTEXT;
  }
}
